/* Peacock Life — Luxe category pages: the filter drawer, sorting without a Go button,
   and Add to cart straight from a product card. */
(function () {
  'use strict';
  if (window.__luxeCollection) return;
  window.__luxeCollection = true;

  function boot() {
    var panel = document.querySelector('[data-lxc-filters]');
    var openBtn = document.querySelector('[data-lxc-filter-open]');
    if (panel && openBtn) {
      var scrim = document.createElement('div');
      scrim.className = 'lxc-scrim';
      document.body.appendChild(scrim);

      var open = function () {
        panel.classList.add('is-open');
        scrim.classList.add('is-on');
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      };
      var close = function () {
        panel.classList.remove('is-open');
        scrim.classList.remove('is-on');
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };

      openBtn.addEventListener('click', open);
      scrim.addEventListener('click', close);
      Array.prototype.forEach.call(document.querySelectorAll('[data-lxc-filter-close]'), function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }

    /* Sorting applies as soon as it changes */
    var sortForm = document.querySelector('[data-lxc-sort-form]');
    if (sortForm) {
      var sel = sortForm.querySelector('select');
      if (sel) sel.addEventListener('change', function () { sortForm.submit(); });
    }

    /* Add to cart straight from a card */
    var toast;
    function say(msg) {
      if (!toast) { toast = document.createElement('div'); toast.className = 'lxc-toast'; document.body.appendChild(toast); }
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(say._t);
      say._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
    }

    function refreshCart(sections) {
      /* Put the theme's own cart drawer and bubble back on the page, then open the drawer */
      try {
        if (sections) {
          Object.keys(sections).forEach(function (key) {
            var html = new DOMParser().parseFromString(sections[key], 'text/html');
            var fresh = html.querySelector('.shopify-section') || html.body.firstElementChild;
            var live = document.getElementById('shopify-section-' + key) ||
                       document.querySelector('cart-drawer') || document.getElementById('cart-icon-bubble');
            if (fresh && live) live.innerHTML = fresh.innerHTML;
          });
        }
      } catch (err) {}
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(); return true; }
      return false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lxc-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var id = btn.getAttribute('data-lxc-add');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Could not add');
          btn.textContent = 'Added';
          btn.classList.add('is-done');
          var opened = refreshCart(data.sections);
          if (!opened) say('Added to cart');
          setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; }, 2400);
        })
        .catch(function (err) {
          btn.textContent = label;
          btn.disabled = false;
          say(err.message || 'Could not add to cart');
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();